import styled from 'styled-components'
import PhoneInput from 'react-phone-input-2'
import OtpInput from 'react-otp-input'
// import "react-phone-input-2/lib/material.css";
import search from 'src/assets/search_icon.png'

export const StyledOTPInput = styled(OtpInput)`
  justify-content: center;
  margin-top: 4em;
`

export const StyledPhoneInput = styled(PhoneInput)`
  width: ${(props) => (props.landing ? '785px' : '400px')};
  height: ${(props) => props.landing && '66px'};
  margin: ${(props) => !props.landing && 'auto'};
  margin-top: ${(props) => !props.landing && '3em'};
  border-radius: ${(props) => (props.landing ? '66px' : '10px')};

  .form-control {
    background: ${(props) => (props.landing ? '#FFFFFF' : '#383838')};
    border: 1px solid #d9d9d9;
    border-radius: ${(props) => (props.landing ? '66px' : '10px')};
    color: ${(props) => (props.landing ? 'black' : 'white')};
    width: ${(props) => (props.landing ? '785px' : '400px')};
    height: ${(props) => props.landing && '66px'};
    font-family: 'heroregular';
    font-size: 18px;
  }

  .selected-flag {
    height: 64px;
    top: -2px;
  }

  .country-list {
    background: ${(props) => (props.landing ? '#FFFFFF' : '#383838')};
  }

  .country {
    display: flex;
  }

  .country-list .search {
    background: ${(props) => (props.landing ? '#FFFFFF' : '#383838')};
  }

  .dial-code {
    color: grey;
    flex: 1;
    text-align: end;
    font-family: 'heroregular';
  }

  .country-name {
    color: grey;
    display: flex;
    flex-direction: row;
    text-align: left;
    font-family: 'heroregular';
  }

  .country-list .search-box {
    border: 1px solid #d8d6d6;
    border-radius: 3px;
    font-size: 15px;
    color: #cccbcb;
    font-family: heroregular;
    line-height: 15px;
    margin-left: 4px;
    padding: 4px 30px 5px;
    outline: none;
    width: 255px;
    display: flex;
  }

  .search-box {
    background: url(${search}) no-repeat scroll 7px 6px;
    padding-left: 30px;
  }

  .country-list.search-box: hover {
    border-color: #d8d6d6;
  }

  .form-control: focus {
    background: ${(props) => (props.landing ? '#FFFFFF' : '#383838')};
    border-color: #d9d9d9;
    box-shadow: 0 0 0 0.1px grey;
  }

  .form-control:hover {
    border-color: #ede8e8;
  }

  .special-label {
    display: none;
  }
`

export const Container = styled.div`
  display: flex;
  background: #1e1f23;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  position: fixed;
`

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  padding: 2.5rem;
  text-align: center !important;
`

export const InputContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 1.2rem;
  text-align: center !important;
`

export const Form = styled.div``

export const Title = styled.div`
  font-weight: 900;
  color: #ffffff;
  font-size: 3.75rem;
  line-height: 1;
  margin-bottom: 20px;
`

export const Desc = styled.div`
  color: #ffffff;
  font-size: 24px;
  font-weight: 300;
  width: 100%;
  margin-right: auto !important;
`

export const Image = styled.img`
  width: 100%;
  height: max-content;
`
export const Logo = styled.img`
  height: 4rem;
  border-radius: 5px;
`
export const Verify = styled.img`
  height: 10rem;
`

export const Caption = styled(Desc)`
  font-size: 15px;
  margin-left: 105px;
  margin-top: 0.3em;
  margin-bottom: 0.2em;
`
export const Resend = styled(Desc)`
  font-size: 17px;
  margin-left: 128px;
  margin-top: 0.5em;
  margin-bottom: 2em;
  color: rgba(142, 142, 142, 1);
  cursor: pointer;
`

export const Wrap = styled.div`
  position: relative;
`

export const Button = styled.button`
  background: #624de3;
  border-radius: 40px;
  border: 2px solid rgba(103, 119, 224, 1);
  min-width: 40%;
  height: 50px;
  display: flex;
  justify-content: center;
  margin: auto;
  font-size: 18px;
  padding: 0.6em 0.5em;
  color: #ffffff;
  font-weight: 800;
  cursor: pointer;
  top: 50px;
  position: relative;
`

export const Captcha = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: column;
`

export const StyledLogoContainer = styled.div`
  display: flex;
`

export const LogoCountryCode = styled.div`
  color: white;
  height: 2px;
  padding-left: 4px;
  padding-top: 48px;
`
